export { UpsIonicCoreModule } from './core.module';

export * from './services';
